module.exports = __webpack_public_path__ + "img/from_toeicBTest_content02.f11e5a85.svg";